import Dashboard from "../views/dashboard/Dashboard";
import Calendar from "../views/user/calendar/index";
import UserComponent from "../views/user/users/Users";
import Property from "../views/user/property/Property";
import AddProperty from "../views/user/property/AddProperty";
import EditProperty from "../views/user/property/EditProperty";
import Tenant from "../views/user/tenant/Tenant";
import AddTenant from "../views/user/tenant/AddTenant";
import EditTenant from "../views/user/tenant/EditTenant";
import Inspection from "../views/user/inspection/Inspection";
import ViewInspection from "../views/user/inspection/ViewInspection";
import AddUser from "../views/user/users/AddUser";
import EditUser from "../views/user/users/EditUser";
import ProfileDetails from "../components/account/ProfileDetails";
import PropertyTimeline from "../views/user/property/PropertyTimeline";
import PropertyLease from "../views/user/propertyLease/PropertyLease";
import AddPropertyLease from "../views/user/propertyLease/AddPropertyLease";
import EditPropertyLease from "../views/user/propertyLease/EditPropertyLease";
import Template from "../views/user/template/Template";
import AddTemplate from "../views/user/template/AddTemplate";
import EditTemplate from "../views/user/template/EditTemplate";
import Notification from "../components/notifications/Notification";
import ComparisonReport from "../views/user/reports/comparison/index";
import ComparisonReportView from "../views/user/reports/comparison/view";
import DepositReport from "../views/user/reports/deposit/index";
import DepositReportAdd from "../views/user/reports/deposit/add";
import DepositReportView from "../views/user/reports/deposit/view";


const User = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: <Dashboard />,
    role: 'user',
    icon: "nc-icon nc-bank",
    show: true
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: <Calendar />,
    role: 'user',
    icon: "nc-icon nc-calendar-60",
    show: true
  },
  {
    path: "/user",
    name: "Users",
    icon: "nc-icon nc-single-02",
    component: <UserComponent />,
    role: 'user',
    layout: "/user",
    show: true
  },
  {
    path: "/account",
    name: "Account",
    icon: "nc-icon nc-circle-10",
    component: <ProfileDetails />,
    role: 'user',
    show: false
  },
  {
    path: "/user/add",
    name: "Add User",
    component: <AddUser />,
    role: 'user',
    show: false
  },
  {
    path: "/user/edit/:id",
    name: "Edit User",
    component: <EditUser />,
    role: 'user',
    show: false
  },
  {
    path: "/property",
    name: "Properties",
    icon: "nc-icon nc-shop",
    component: <Property />,
    role: 'user',
    show: true
  },
  {
    path: "/property/add",
    name: "Add Property",
    component: <AddProperty />,
    role: 'user',
    show: false
  },
  {
    path: "/property/edit/:id",
    name: "Edit Property",
    component: <EditProperty />,
    role: 'user',
    show: false
  },

  {
    path: "/property/timeline/:id",
    name: "View Property Timeline",
    component: <PropertyTimeline />,
    role: 'user',
    show: false
  },

//   {
//     path: "/tenant",
//     name: "Renters",
//     icon: "nc-icon nc-key-25",
//     component: <Tenant />,
//     role: 'user',
//     show: true
//   },
//   {
//     path: "/tenant/add",
//     name: "Add Renter",
//     component: <AddTenant />,
//     role: 'user',
//     show: false
//   },
//   {
//     path: "/tenant/edit/:id",
//     name: "Edit Renter",
//     component: <EditTenant />,
//     role: 'user',
//     show: false
//   },
  {
    path: "/inspection",
    name: "Inspections",
    icon: "nc-icon nc-camera-compact",
    component: <Inspection />,
    role: 'user',
    show: true
  },
  {
    path: "/inspection/view/:id",
    name: "View Inspection",
    component: <ViewInspection />,
    role: 'user',
    show: false
  },
  {
    path: "/lease",
    name: "Renters",
    icon: "nc-icon nc-paper",
    component: <PropertyLease />,
    role: 'user',
    show: true
  },
  {
    path: "/lease/edit/:id",
    name: "Edit Property Lease",
    component: <EditPropertyLease />,
    role: 'user',
    show: false
  },
  {
    path: "/lease/add",
    name: "Add Property Lease",
    component: <AddPropertyLease />,
    role: 'user',
    show: false
  },
  {
    path: "/template",
    name: "Templates",
    icon: "nc-icon nc-layout-11",
    component: <Template />,
    role: 'user',
    show: true
  },
  {
    path: "/template/add",
    name: "Add Template",
    component: <AddTemplate />,
    role: 'user',
    show: false
  },
  {
    path: "/template/edit/:id",
    name: "Edit Template",
    component: <EditTemplate />,
    role: 'user',
    show: false
  },
  
  {
	path: "/reports",
    name: "Reports",
	icon: "nc-icon nc-single-copy-04",
	role: 'user',
	show: true,
	sub_routes: [
			{
				path: "/comparison-report",
				name: "Comparison Report",
				component: <ComparisonReport />,
				show: true
			},
			{
				path: "/comparison-report-view",
				name: "Comparison Report View",
				component: <ComparisonReportView />,
				show: false
			},
			{
				path: "/comparison-report-view/:id",
				name: "Comparison Report View",
				component: <ComparisonReportView />,
				show: false
			},
			{
				path: "/deposit-withholding-report",
				name: "Deposit Withholding",
				component: <DepositReport />,
				show: true
			},
			{
				path: "/deposit-withholding-report/add",
				name: "Add Deposit Withholding",
				component: <DepositReportAdd />,
				show: false
			},
			{
				path: "/deposit-withholding-report/view/:id",
				name: "View Deposit Withholding",
				component: <DepositReportView />,
				show: false
			},
		]
	},
	{
		path: "/notifications",
		name: "Notifications",
		icon: "nc-icon nc-single-02",
		component: <Notification />,
		role: 'user',
	},
];
export default User;
